import { datadogRum } from '@datadog/browser-rum';
import { Brand, DataDogService } from 'constants/index';
import packageJson from '../../package.json';

const getBrandService: AnyObject = {
  [Brand.FOX]: DataDogService.FOX,
  [Brand.NATION]: DataDogService.NATION,
  [Brand.SPORTS]: DataDogService.SPORTS,
};

export default function initializeDataDog(config: AnyObject = {}): void {
  if (config) {
    const { applicationId, clientToken, env, site } = config;
    datadogRum.init({
      applicationId,
      clientToken,
      site,
      service: getBrandService[process.env.NEXT_PUBLIC_BRAND as string],
      env,
      version: packageJson.version,
      sampleRate: 100,
      trackInteractions: true,
      defaultPrivacyLevel: 'mask-user-input',
    });
    datadogRum.startSessionReplayRecording();
  }
}
